var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.646 8.909c.995.856 1.72 1.817 1.72 3.091 0 1.274-.725 2.235-1.72 3.091-.968.834-2.387 1.73-4.148 2.842l-1.735 1.096c-1.99 1.257-3.582 2.262-4.874 2.833-1.312.58-2.601.843-3.809.178-1.207-.665-1.673-1.896-1.883-3.315-.207-1.397-.207-3.28-.207-5.634V10.91c0-2.354 0-4.237.207-5.634.21-1.419.676-2.65 1.883-3.315 1.208-.665 2.497-.402 3.81.178 1.291.57 2.883 1.576 4.873 2.833l1.735 1.096c1.76 1.112 3.18 2.008 4.148 2.842Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.8dddc145594fd13de3ab227f5c508cd4.svg";
export { ForwardRef as ReactComponent };